import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=3ad714b0&scoped=true&"
import script from "./ReportDetail.vue?vue&type=script&lang=ts&"
export * from "./ReportDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=3ad714b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad714b0",
  null
  
)

export default component.exports